import { UUID } from '@lib/types/general'
import { map, path, split, useWith } from 'ramda'

// eslint-disable-next-line
export const dotPath = useWith(path, [split('.')])

export const partitionByIndex = (arr = [], index) => [
  arr.slice(0, index),
  arr.slice(index),
]

export const ellipsize = (length) => (text) =>
  text.length > length ? `${text.substr(0, length)}...` : text

export const getListIds: (list: any[]) => UUID[] = map(({ id }) => id)

export const toMap = (list: any[], idProp = 'id') =>
  list.reduce((h, curr) => {
    return {
      ...h,
      [curr[idProp]]: curr,
    }
  }, {})

export const debounce = (timeMs: number, fn: Function) => {
  let _timeout = null

  return (...params: any[]) => {
    if (_timeout) clearTimeout(_timeout)

    return new Promise((resolve) => {
      _timeout = setTimeout(() => resolve(fn(...params)), timeMs)
    })
  }
}

export const debounceWithCancel = (timeMs: number, fn: Function) => {
  let _timeout = null

  const promise = (...params: any[]) => {
    if (_timeout) clearTimeout(_timeout)

    return new Promise((resolve) => {
      _timeout = setTimeout(() => resolve(fn(...params)), timeMs)
    })
  }

  return { promise, cancel: () => clearTimeout(_timeout) }
}
